const Survey = () => import('../views/survey/Survey.vue')
const Survey2 = () => import('../views/survey2/Survey.vue')
const SingaporeSurvey = () => import('../views/surveys/singapore/Survey.vue')
const SydneySurvey = () => import('../views/surveys/sydney/Survey.vue')
const SapporoSurvey = () => import('../views/surveys/sapporo/Survey.vue')

export default [
  {
    path: '/survey/PF22/:wave_number',
    name: 'croatia-survey',
    component: Survey
  },
  {
    path: '/survey/CM/:wave_number',
    name: 'chiangmai-survey',
    component: Survey2
  },
  {
    path: '/survey/SG/:wave_number',
    name: 'singapore-survey',
    component: SingaporeSurvey
  },
  {
    path: '/survey/Sydney/:wave_number',
    name: 'sydney-survey',
    component: SydneySurvey
  },
  {
    path: '/survey/Sapporo/:wave_number',
    name: 'sapporo-survey',
    component: SapporoSurvey
  },
  ]